/* eslint-disable */
export default {
   dateToUnixtimestamp (dateObj, time) {
  // 时间戳
  // return dateObj.getTime() / 1000
     console.log(dateObj);
  return ((dateObj.setHours(0, 0, 0 ,0)) + time * 3600 * 24 * 1000)/1000
  },
  // 时间戳格式化时间日期
  formatTime (time, cFormat) {
    if (arguments.length === 0) return null
    if ((time + '').length === 10) {
      time = +time * 1000
    }

    let format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}',
      date
    if (typeof time === 'object') {
      date = time
    } else {
      date = new Date(time)
    }

    var formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    let time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      var value = formatObj[key]
      if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return time_str
  },
  formateDateTime (date) {
    let dateArray = date.splite("-");
    let yyyy = dateArray[0];
    let MM = dateArray[1].length < 2 ? "0" + dateArray[1] : dateArray[1];
    let DD = dateArray[2].length < 2 ? "0" + dateArray[2] : dateArray[2];
  },
  dataURItoBlob (dataURI) {
    let bytes =
      dataURI.split(",")[0].indexOf("base64") >= 0
        ? atob(dataURI.split(",")[1])
        : unescape(dataURI.split(",")[1]);
    let mime = dataURI
      .split(",")[0]
      .split(":")[1]
      .split(";")[0];
    let max = bytes.length;
    let ia = new Uint8Array(max);
    for (let i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
    return new Blob([ia], {type: mime});
  },
  download (url) {
     window.open(url)
  }
}
